module.exports = __webpack_public_path__ + "static/img/ko.d19f9afa.png";